<div mat-dialog-content style="height: 300px; width: 400px;">
  <br>
  <h2>{{ data.caption }}</h2>
  <br>
  <div class="loader"></div> 
</div>
<br>
